module.exports = __webpack_public_path__ + "img/theme-6-orange.1ac198a8.svg";